var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.0001 20.3327C16.6025 20.3327 20.3334 16.6017 20.3334 11.9993C20.3334 7.39698 16.6025 3.66602 12.0001 3.66602C7.39771 3.66602 3.66675 7.39698 3.66675 11.9993C3.66675 16.6017 7.39771 20.3327 12.0001 20.3327Z",
    fill: "#0A5AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5423C11.6583 10.5423 11.375 10.8257 11.375 11.1673V15.334C11.375 15.6757 11.6583 15.959 12 15.959C12.3417 15.959 12.625 15.6757 12.625 15.334V11.1673C12.625 10.8257 12.3417 10.5423 12 10.5423Z",
    fill: "#0A5AF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2333 8.98359C11.2749 9.08359 11.3333 9.17526 11.4083 9.25859C11.4916 9.33359 11.5833 9.39193 11.6833 9.43359C11.8833 9.51693 12.1166 9.51693 12.3166 9.43359C12.4166 9.39193 12.5083 9.33359 12.5916 9.25859C12.6666 9.17526 12.7249 9.08359 12.7666 8.98359C12.8083 8.88359 12.8333 8.77526 12.8333 8.66693C12.8333 8.55859 12.8083 8.45026 12.7666 8.35026C12.7249 8.24193 12.6666 8.15859 12.5916 8.07526C12.5083 8.00026 12.4166 7.94193 12.3166 7.90026C12.2166 7.85859 12.1083 7.83359 11.9999 7.83359C11.8916 7.83359 11.7833 7.85859 11.6833 7.90026C11.5833 7.94193 11.4916 8.00026 11.4083 8.07526C11.3333 8.15859 11.2749 8.24193 11.2333 8.35026C11.1916 8.45026 11.1666 8.55859 11.1666 8.66693C11.1666 8.77526 11.1916 8.88359 11.2333 8.98359Z",
    fill: "#0A5AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.92117c66764ecc4d840b3b5b1cc0880a.svg";
export { ForwardRef as ReactComponent };